import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/usersToSubsidiaries'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  userToSubsidiary: {},
  usersToSubsidiaries: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  userToSubsidiary: state => state.userToSubsidiary,
  usersToSubsidiaries: state => state.usersToSubsidiaries
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_USER_TO_SUBSIDIARY = 'REQUEST_GET_USER_TO_SUBSIDIARY'
const RECEIVE_GET_USER_TO_SUBSIDIARY = 'RECEIVE_GET_USER_TO_SUBSIDIARY'

const REQUEST_CREATE_USER_TO_SUBSIDIARY = 'REQUEST_CREATE_USER_TO_SUBSIDIARY'
const RECEIVE_CREATE_USER_TO_SUBSIDIARY = 'RECEIVE_CREATE_USER_TO_SUBSIDIARY'

const REQUEST_UPDATE_USER_TO_SUBSIDIARY = 'REQUEST_UPDATE_USER_TO_SUBSIDIARY'
const RECEIVE_UPDATE_USER_TO_SUBSIDIARY = 'RECEIVE_UPDATE_USER_TO_SUBSIDIARY'

const REQUEST_DELETE_USER_TO_SUBSIDIARY = 'REQUEST_DELETE_USER_TO_SUBSIDIARY'
const RECEIVE_DELETE_USER_TO_SUBSIDIARY = 'RECEIVE_DELETE_USER_TO_SUBSIDIARY'

const UPDATE_USER_TO_SUBSIDIARY_PROPERTY = 'UPDATE_USER_TO_SUBSIDIARY_PROPERTY'

const REQUEST_GET_USERS_TO_SUBSIDIARIES = 'REQUEST_GET_USERS_TO_SUBSIDIARIES'
const RECEIVE_GET_USERS_TO_SUBSIDIARIES = 'RECEIVE_GET_USERS_TO_SUBSIDIARIES'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getUsersToSubsidiaries ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting usersToSubsidiaries', { root: true })
    commit(REQUEST_GET_USERS_TO_SUBSIDIARIES)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveUsersToSubsidiaries', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting usersToSubsidiaries', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting usersToSubsidiaries', { root: true })
        return Promise.reject(error)
      })
  },
  async getUserToSubsidiary ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting userToSubsidiary', { root: true })
    commit(REQUEST_GET_USER_TO_SUBSIDIARY, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveUserToSubsidiary', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting userToSubsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting userToSubsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async createUserToSubsidiary ({ commit, dispatch }, { data, includes = undefined }) {
    dispatch('wait/start', 'creating userToSubsidiary', { root: true })
    commit(REQUEST_CREATE_USER_TO_SUBSIDIARY, data)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.post(`${endpointConfig.url}`, data, config)
      .then((response) => {
        dispatch('receiveUserToSubsidiary', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating userToSubsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating userToSubsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async updateUserToSubsidiary ({ commit, dispatch }, { id, data, includes = undefined }) {
    dispatch('wait/start', 'updating userToSubsidiary', { root: true })
    commit(REQUEST_UPDATE_USER_TO_SUBSIDIARY, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.put(`${endpointConfig.url}/${id}`, data, config)
      .then((response) => {
        dispatch('receiveUserToSubsidiary', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating userToSubsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating userToSubsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteUserToSubsidiary ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting userToSubsidiary', { root: true })
    commit(REQUEST_DELETE_USER_TO_SUBSIDIARY, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_USER_TO_SUBSIDIARY, response.data)
        dispatch('wait/end', 'deleting userToSubsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting userToSubsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  receiveUserToSubsidiary ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_USER_TO_SUBSIDIARY`, extract(json))
    return json.data
  },
  receiveUsersToSubsidiaries ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_USERS_TO_SUBSIDIARIES`, extract(json))
    return json.data
  },
  updateUserToSubsidiaryProperty ({ commit }, [ property, value ]) {
    commit(`UPDATE_USER_TO_SUBSIDIARY_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_USER_TO_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_GET_USER_TO_SUBSIDIARY] (state, json) {
    state.userToSubsidiary = json
  },
  [REQUEST_CREATE_USER_TO_SUBSIDIARY] (state, json) {
  },
  [RECEIVE_CREATE_USER_TO_SUBSIDIARY] (state, json) {
    state.userToSubsidiary = json
  },
  [REQUEST_UPDATE_USER_TO_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_UPDATE_USER_TO_SUBSIDIARY] (state, json) {
    state.userToSubsidiary = json
  },
  [REQUEST_DELETE_USER_TO_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_DELETE_USER_TO_SUBSIDIARY] (state, json) {
    state.userToSubsidiary = {}
  },
  [UPDATE_USER_TO_SUBSIDIARY_PROPERTY] (state, [ property, value ]) {
    state.userToSubsidiary[property] = value
  },
  [REQUEST_GET_USERS_TO_SUBSIDIARIES] (state) {
  },
  [RECEIVE_GET_USERS_TO_SUBSIDIARIES] (state, json) {
    state.usersToSubsidiaries = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
